import { Link } from 'react-router-dom';
import { doctors } from '@/mocks/home';
import { fetchDoctorList } from '@/services/doctor';
import { adaptDoctors } from '@/services/adapters';
import { useRequest } from '@/hooks/useRequest';
import SectionHeading from '@/components/base/SectionHeading';
import DoctorCard from '@/components/feature/DoctorCard';

const HOME_LIMIT = 4;

export default function DoctorsSection() {
  // 接口失败时降级为 mock 数据
  const { data: doctorList } = useRequest(
    () => fetchDoctorList({ pageIndex: 1, pageSize: HOME_LIMIT }).then((res) => adaptDoctors(res.list)),
    { fallback: doctors.slice(0, HOME_LIMIT) },
  );

  // 无数据时整段隐藏，避免出现只有标题与按钮的空板块
  if (doctorList.length === 0) return null;

  return (
    <section id="doctors" className="scroll-mt-24 w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="医师团队"
          title="名老中医与骨干医师"
          description="汇聚国家级名老中医与三甲医院骨干医师，以中西医结合之力守护全周期健康。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {doctorList.map((doctor) => (
            <DoctorCard key={doctor.id} doctor={doctor} showAction={false} />
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/doctors"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部医师
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}